'use strict';

var ROMAnalysisSkinnyModeFilterFactory = function ROMAnalysisSkinnyModeFilterFactory(DemandFilter, angularHelper) {
  var filtersNamesList = ['ROMAnalysisCabinFilterFactory', 'ROMOptGroupWeekFilterFactory', 'ROMAnalysisPOSFilterFactory'];
  var injectedFilters = angularHelper.getProvidersByNames(filtersNamesList);
  function ROMAnalysisSkinnyModeFilterFactory() {
    DemandFilter.call(this, ['rom-analysis-skinny-services-mode'], ['kpi-ribbon', 'market-indicators']);
    this.registerFilters(injectedFilters);
  }
  ROMAnalysisSkinnyModeFilterFactory.constructor = ROMAnalysisSkinnyModeFilterFactory;
  ROMAnalysisSkinnyModeFilterFactory.prototype = Object.create(DemandFilter.prototype);
  ROMAnalysisSkinnyModeFilterFactory.prototype.canFilter = function (sourceType, targetType) {
    return this.sourceType.indexOf(sourceType) !== -1 && this.targetType.indexOf(targetType) !== -1;
  };
  return ROMAnalysisSkinnyModeFilterFactory;
};
ROMAnalysisSkinnyModeFilterFactory.$inject = ['DemandFilterFactory', 'AngularHelper'];
module.exports = ROMAnalysisSkinnyModeFilterFactory;